import { render, staticRenderFns } from "./BlockLine.vue?vue&type=template&id=920d1754&scoped=true&"
import script from "./BlockLine.vue?vue&type=script&lang=js&"
export * from "./BlockLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920d1754",
  null
  
)

export default component.exports